window.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.feature-content .button');

  if (!buttons.length > 0) return;

  buttons.forEach((button) => {
    button.addEventListener('mouseover', () => {
      button.closest('.feature-content').classList.add('hover');
    });

    button.addEventListener('mouseout', () => {
      button.closest('.feature-content').classList.remove('hover');
    });
  });
});
